import barba from '@barba/core';
import gsap from 'gsap';
import * as $ from 'jquery';
import LocomotiveScroll from 'locomotive-scroll'
// import {globalscroll} from './smoothscroll'
import {burgersetup} from './burger'
// import {Fontf}
import {scrollanimation} from './scrollanimation'
import {scrollthankyou} from './special'
import {pageload10th,bigxcall,starsmove,titleload} from './index'
import {call_fallstars,scrollanimationforproject} from './projects'
import {scrollanimationfortrack} from './track'
import FontFaceObserver from 'fontfaceobserver';
import {projectjavascript} from './project';
$(document).ready(function() {
const scroll = new LocomotiveScroll({
    el: document.querySelector('[data-scroll-container]'),
    smooth: true,
    mobile: {
      smooth: true
    },
    tablet: {
      smooth: true
    },
    smartphone: {
      smooth: true
    },
});
const fontThai = new Promise(resolve => {
  new FontFaceObserver("HelveticaNeue").load().then(() => {
      console.log("font load")
      resolve();
  },5000)
})
    

// const scroll = globalscroll()
console.log("from barba app")
var oncetime = 0;

barba.init({
  timeout: 10000,
  transitions: [{
      // name: 'opacity-transition',
      leave(data) {
          console.log("leave")
        return gsap.to(data.current.container, {duration:0.5,
          opacity: 0,
          onStart: ()=>{
          },
          onComplete: ()=>{

          }
        });
      },
      enter(data) {
          console.log("enter")

      },
      once(data){
          // scroll = globalscroll()
          fontThai.then(()=>{
            pageload10th()
            burgersetup()
          })


      },
      after(data){
        console.log("after")
        scroll.init ();
        scroll.update()
        burgersetup()
        
        return gsap.from(data.next.container, {duration:0.5,
          opacity: 0,
          onComplete: ()=>{
          }
        });

      },
      beforeLeave(data){
        scroll.destroy()
        
      }
    }],
          views: [
        {
        namespace: 'projects',
        afterEnter(data) {
          console.log("after enter")
        scrollanimationforproject(scroll)
          call_fallstars()

        },

        beforeEnter(data) {


        }
      }, {
        namespace: 'home1',
        afterEnter(data) {
          // do something before entering the `contact` namespace
          console.log("enter to home1")
            scrollanimation(scroll)
            starsmove()
            titleload()
            bigxcall()

          
        },
        beforeEnter(data){



        }
      }, {
        namespace: 'project',
        afterEnter(data) {
          console.log("enter project ")
          // do something before entering the `contact` namespace
          projectjavascript()

          
        },
        beforeEnter(data){



        }
      }, {
        namespace: 'aboutthesis',
        afterEnter(data) {
          console.log("enter about thesis ")
          // do something before entering the `contact` namespace

          scrollanimationfortrack(scroll)

          
        },
        beforeEnter(data){



        }
      }, {
        namespace: 'specialthank',
        afterEnter(data) {
          console.log("thankyou for visiting our thesis ")
          // do something before entering the `contact` namespace
          scrollthankyou(scroll)

          
        },
        beforeEnter(data){



        }
      }]
    
});


// barba.init({

//     transitions: [{
//         // name: 'opacity-transition',
//         leave(data) {
//             console.log("leave")
//           return gsap.to(data.current.container, {duration:1,
//             opacity: 0,
//             onComplete: ()=>{

//             }
//           });
//         },
//         enter(data) {
//             console.log("enter")

//         },
//         once(data){
//             pageload10th()
//             burgersetup()
//             scrollanimation(scroll)

//         },
//         after(data){
//           oncetime = 1
//           scroll.update();
//           burgersetup()
//           scrollanimation(scroll)
          
//           return gsap.from(data.next.container, {duration:1,
//             opacity: 0,
//             onComplete: ()=>{
//                 // burgersetup()
//             }
//           });

//         },
//         beforeLeave(data){
//           scroll.scrollTo(0)
//         }
//       }],
//       views: [
//         {
//           namespace: 'project',
//           beforeEnter(data) {
//             call_fallstars()
//             scrollanimationforproject(scroll)
//           }
//         }
//         ,{
//         namespace: 'home1',
//         beforeLeave(data) {
//           // do something before leaving the current `index` namespace

//         }
//       }, {
//         namespace: 'home1',
//         afterEnter(data) {
//           // do something before entering the `contact` namespace
//           console.log("enter to home1")
//           // titleload()
//           starsmove()
//           bigxcall()
          
//         },
//         beforeEnter(data){
//           console.log("before enter home1")
//           titleload()

//         }
//       }]
//   });

  function delay(n) {
    n = n || 2000;
    return new Promise(done => {
        setTimeout(()=>{
            done()
        },n);
    })
}
var url = 'sitemap.html'; //A local page
var xml = `<?xml version="1.0" encoding="UTF-8"?>
<urlset
      xmlns="http://www.sitemaps.org/schemas/sitemap/0.9"
      xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
      xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9
            http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
<!-- created with Free Online Sitemap Generator www.xml-sitemaps.com -->


<url>
  <loc>https://commuexhibition.com/</loc>
  <lastmod>2021-05-05T21:27:21+00:00</lastmod>
  <priority>1.00</priority>
</url>
<url>
  <loc>https://commuexhibition.com/index.html</loc>
  <lastmod>2021-05-05T21:27:21+00:00</lastmod>
  <priority>0.80</priority>
</url>
<url>
  <loc>https://commuexhibition.com/projects.html</loc>
  <lastmod>2021-05-05T21:27:21+00:00</lastmod>
  <priority>0.80</priority>
</url>
<url>
  <loc>https://commuexhibition.com/track.html</loc>
  <lastmod>2021-05-05T21:27:21+00:00</lastmod>
  <priority>0.80</priority>
</url>
<url>
  <loc>https://commuexhibition.com/project1.html</loc>
  <lastmod>2021-05-05T21:27:21+00:00</lastmod>
  <priority>0.64</priority>
</url>
<url>
  <loc>https://commuexhibition.com/project2.html</loc>
  <lastmod>2021-05-05T21:27:21+00:00</lastmod>
  <priority>0.51</priority>
</url>


</urlset>`
function load(url, callback) {
  var xhr = new XMLHttpRequest();

  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4) {
      callback(xhr.response);
    }
  }

  xhr.open('GET', url, true);
  xhr.send(xml);
}

})
